import styled from 'styled-components';

export const LabelText = styled.span`
  display: inline-block;
  align-self: center;
  line-height: 21px;
  text-align: left;
  width: 630px;
`;

export const ButtonsWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  margin-top: 200px;
  justify-content: flex-end;
  width: 730px;
`;

export const ViewAlaButtonWrapper = styled.div`
  height: 30px;
  min-width: 750px;
  
  > div {
    margin-top: -51px;
  }
`;
